import React, { useState } from 'react';
import { IUser } from '../../Interfaces/IUser';
import { IUserGroup } from '../../Interfaces/IUserGroup';
import { useSearchLegalTransactions } from '../../hooks/data';
import {
  Accordion,
  AccordionSummary,
  Alert,
  Avatar,
  Box,
  CardContent,
  Grid,
  IconButton,
  Skeleton,
  Typography,
} from '@mui/material';
import {
  ChevronLeft,
  ChevronRight,
  FilterFrames,
  Group,
} from '@mui/icons-material';
import { GridExpandMoreIcon } from '@mui/x-data-grid';
import { AccordionLegend } from './AccordionLegend';
import { ILegalTransactionProgress } from '../../Interfaces/ILegalTransactionProgress';
import {
  getUserAvatarProps,
  instantViewLegalTransaction,
  spanTsx,
  stringAvatar,
} from './helpers';

interface IProps {
  userArray: IUser[];
  userGroupArray: IUserGroup[];
  legalTransactionProgressArray: ILegalTransactionProgress[];
}

export const CardKanbanLegalTransaction: React.FC<IProps> = ({
  userArray,
  userGroupArray,
  legalTransactionProgressArray,
}) => {
  const [page, setPage] = useState(1);
  //
  const searchUri = `page=${page}&rowsPerPage=${10}`;

  const {
    legalTransactions,
    isLoadingLegalTransactions,
    abortSearchLegalTransactions,
  } = useSearchLegalTransactions(searchUri);

  if (isLoadingLegalTransactions) {
    return <Skeleton height={500} />;
  }
  if (!legalTransactions) {
    return <Alert severity='error'>Es ist ein Fehler aufgetretten!</Alert>;
  }

  return (
    <>
      <CardContent>
        <Grid container>
          <Grid item sm={4}>
            <FilterFrames sx={{ m: 2, mb: 1, fontSize: 30 }} />
            <Typography>Alle offenen Vorgänge</Typography>
          </Grid>
          <Grid item sm={4}>
            <IconButton
              title='Vorherige Vorgänge anzeigen'
              disabled={page === 1}
              onClick={() => setPage(prev => prev - 1)}
            >
              <ChevronLeft />
            </IconButton>
            <IconButton
              title='Nächste Vorgänge anzeigen'
              onClick={() => setPage(prev => prev + 1)}
            >
              <ChevronRight />
            </IconButton>
          </Grid>
          <Grid item sm={4}>
            <AccordionLegend />
          </Grid>
        </Grid>

        <Grid container spacing={1}>
          {legalTransactionProgressArray.map(progress => (
            <Grid
              item
              xs={12 / legalTransactionProgressArray.length}
              sx={{ borderRight: 'solid' }}
            >
              <Box sx={{ mt: 3, mb: 3, textAlign: 'center' }}>
                <b>
                  <u>{progress.LegalTransactionProgress}</u>
                </b>
              </Box>

              {legalTransactions
                .filter(x => x.Closed_at == undefined)
                .filter(
                  x =>
                    x.idLegalTransactionProgress ===
                    progress.idLegalTransactionProgress
                )
                .map(legalTransaction => {
                  const userNotary = userArray.find(
                    x => x.idUser === legalTransaction.Notary_idUser
                  );
                  const userEmployee = userArray.find(
                    x => x.idUser === legalTransaction.Employee_idUser
                  );
                  const userGroup = legalTransaction.UserGroup;

                  return (
                    <Box
                      sx={{ cursor: 'pointer', mt: 2 }}
                      //onClick={() => navigation(`/legaltransaction/${legalTransaction!.idLegalTransaction}`)}
                      onClick={() =>
                        window.open(
                          `/legaltransaction/${legalTransaction!.idLegalTransaction}`,
                          '_blank'
                        )
                      }
                    >
                      {instantViewLegalTransaction(legalTransaction)}

                      <Box sx={{ display: 'flex' }}>
                        {userNotary !== undefined ? (
                          <Avatar
                            {...getUserAvatarProps(userNotary)}
                            alt={`${userNotary.FirstName} ${userNotary.LastName}`}
                          />
                        ) : (
                          spanTsx('#000', '#fff')
                        )}
                        {userEmployee !== undefined ? (
                          <Avatar
                            {...getUserAvatarProps(userEmployee)}
                            alt={`${userEmployee.FirstName} ${userEmployee.LastName}`}
                          />
                        ) : legalTransaction.idUserGroup !== null &&
                          userGroup !== undefined ? (
                          <>
                            <Avatar
                              {...stringAvatar(`${userGroup}`)}
                              alt={`${userGroup}`}
                            />
                            <Group sx={{ ml: -2, mt: 2, zIndex: 100 }} />
                          </>
                        ) : (
                          spanTsx('#fff', '#000', null, 40)
                        )}
                      </Box>
                    </Box>
                  );
                })}
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </>
  );
};
